import React from "react";
import { PrimaryButton, DefaultButton, Stack } from "@fluentui/react";
import { EditionType } from "../../AppGlobals";

interface Props {
    selectedEdition: EditionType | null;
    setSelectedEdition: (edition: EditionType) => void;
    onContinue: () => void;
    onBack: () => void;
}

export const StepEdition: React.FC<Props> = ({ selectedEdition, setSelectedEdition, onContinue, onBack }) => {

    return (
        <div className="step-edition-container">

            <h2 className="create-account-heading">Select Your Edition</h2>

            <div className="step-edition-intro">
                Based on the size of your organisation we will recommend the most
                suitable ZedX edition. You can still choose any edition regardless
                of organisation size.
            </div>

            <div className="step-edition-grid">

                {/* GROUP */}

                <div
                    className={`step-edition-card ${selectedEdition === EditionType.Group ? "selected" : ""}`}
                    onClick={() => setSelectedEdition(EditionType.Group)}
                >
                    <div className="step-edition-title">
                        Group
                    </div>

                    <div className="step-edition-desc">
                        Ideal for small organisations that need a simple and
                        effective governance and risk management platform.
                    </div>

                    <ul className="step-edition-features">
                        <li>Core applications</li>
                        <li>Basic reporting</li>
                        <li>Standard support</li>
                    </ul>
                </div>


                {/* PROFESSIONAL */}

                <div
                    className={`step-edition-card ${selectedEdition === EditionType.Professional ? "selected" : ""}`}
                    onClick={() => setSelectedEdition(EditionType.Professional)}
                >
                    <div className="step-edition-title">
                        Professional
                    </div>

                    <div className="step-edition-desc">
                        Designed for growing organisations that require more
                        advanced configuration and reporting capabilities.
                    </div>

                    <ul className="step-edition-features">
                        <li>All Group features</li>
                        <li>Advanced reporting</li>
                        <li>More integrations</li>
                    </ul>
                </div>


                {/* CORPORATE */}

                <div
                    className={`step-edition-card ${selectedEdition === EditionType.Corporate ? "selected" : ""}`}
                    onClick={() => setSelectedEdition(EditionType.Corporate)}
                >
                    <div className="step-edition-title">
                        Corporate
                    </div>

                    <div className="step-edition-desc">
                        Best suited for large organisations requiring advanced
                        governance, risk and compliance management.
                    </div>

                    <ul className="step-edition-features">
                        <li>All Professional features</li>
                        <li>Advanced security</li>
                        <li>Priority support</li>
                    </ul>
                </div>


                {/* ENTERPRISE */}

                <div className="step-edition-card disabled">

                    <div className="step-edition-title">
                        Enterprise
                    </div>

                    <div className="step-edition-desc">
                        Enterprise deployments with bespoke configuration,
                        integrations and dedicated infrastructure.
                    </div>

                    <div className="step-edition-enterprise">
                        Please contact our team to discuss Enterprise solutions.
                    </div>

                    <DefaultButton text="Contact Us" />

                </div>

            </div>

            <Stack horizontal tokens={{ childrenGap: 12 }} className="step-actions-btns">
                <DefaultButton text="Back" onClick={onBack} />
                <PrimaryButton text="Continue" disabled={!selectedEdition} onClick={onContinue} />
            </Stack>

        </div>
    );
};